import React, { useEffect } from "react";
import { GetServerSidePropsContext } from "next";
import { useRouter } from "next/router";
import {  useDispatch, useSelector } from "react-redux";
import Head from "next/head";

import {ShareInfo} from "@/assets/apitype/share";
import { RootState } from "@/store";
import { userSaveSlice } from "@/store/userSave";
import CheckAuth from "@/components/common/CheckAuth";
import { checkPermission } from "@/store/common";

//Page Props
import { PageProps } from "@/assets/pageprops/index";
import SelectShareDialog from "@/components/common/ConfirmShareDialog"
import * as storageUtil from "@/util/storageUtil";
import * as viewUtil from "@/util/viewUtil";

//URL パラメータの受け取り
export async function getServerSideProps(context:GetServerSidePropsContext) {
  return {
    props: {
      code: viewUtil.getQueryStringOne(context.query.code),
      share: viewUtil.getQueryStringOne(context.query.share),
    },
  }
}

//Main
const Index = (props: PageProps): JSX.Element => {
  const router = useRouter();

  //Store, Dispatcher
  const dispatch = useDispatch();
  const userStore = useSelector((state: RootState) => state.user);
  const userSaveStore = useSelector((state: RootState) => state.userSave);

  const [shareID, setShareID] = React.useState('');

  const [openShareDialog, setOpenShareDialog] = React.useState(false);

  //DEF componentDidMount
  const componentDidMount = ()=>{
      dispatch(userSaveSlice.actions.initOnDidMount());

      //URL共有があれば判断を促す
      const share = storageUtil.getLimitedItem('share=' + props.share);
      if(share) {
        setShareID(share);
        setOpenShareDialog(true);
      }
      else if (userSaveStore.url) {
        router.push(userSaveStore.url);
      }
  };

  //DEF componentWillUnmount
  const componentWillUnmount = ()=>{
    dispatch(userSaveSlice.actions.resetOnWillUnmount());
  }

  useEffect(() => {
    //DO componentWillUnmount
    componentDidMount.bind(this)();
    return ()=>{
      //DO componentWillUnmount
      componentWillUnmount.bind(this)();
    }
  }, []); //Empty

  useEffect(() => {
    if (!userStore.isAuthed || shareID || userSaveStore.url) {
      //認証前、URL共有、前回画面あり
      if (userStore.permissions.indexOf('zaiko-only') !== -1) {
        const checkUrl = userSaveStore.url
          .replace(/\?.*$/, ""); // ?以降を削る
        const page = ['/zaikosummary', '/zaikokigen', '/zaikoreal',]
          .find(url => checkUrl.lastIndexOf(url) === -1 ? false : (checkUrl.lastIndexOf(url) + url.length == checkUrl.length));
        if (page) {
          //閲覧可能なページ
          return;
        }
      }
      else if (userStore.permissions.indexOf('tokubai-only') !== -1) {
        const checkUrl = userSaveStore.url
          .replace(/\?.*$/, ""); // ?以降を削る
        const page = ['/tokubai/manage', '/tokubai/progress',]
          .find(url => checkUrl.lastIndexOf(url) === -1 ? false : (checkUrl.lastIndexOf(url) + url.length == checkUrl.length));
        if (page) {
          //閲覧可能なページ
          return;
        }
      }
      else {
        return;
      }
    }

    if (userStore.permissions.indexOf('zaiko-only') !== -1) {
      //センター別滞留在庫内訳画面に遷移する
      router.push('/zaikosummary');
    } else if (userStore.permissions.indexOf('tokubai-only') !== -1) {
      //特売管理画面に遷移する
      router.push('/tokubai/manage');
    } else if (userStore.permissions.indexOf('report-visible') !== -1) {
      //販売実績一覧画面に遷移する
      router.push('/saleslist');
    } else if (userStore.permissions.indexOf('tokubai-visible') !== -1) {
      //特売管理画面に遷移する
      router.push('/tokubai/manage');
    } else {
      console.log("閲覧権限なし");
      router.push('/nopermissions');
  }
  }, [userStore.permissions]);

  //handler
  const handleShareDialogOK = (shareinfo:ShareInfo) => {
    //localstorageに保存
    storageUtil.setLimitedItem('shareInfo=' + props.share, JSON.stringify(shareinfo), 60);
    storageUtil.removeLimitedItem('share=' + props.share);
    const query = {
      share : shareinfo.uuid
    };

    //権限チェック
    if (!checkPermission(shareinfo.url, userStore.permissions)) {
      console.log("閲覧権限なし");
      router.push('/nopermissions');
      return;
    }
    //販売実績一覧画面に遷移する
    router.push({
      pathname:shareinfo.url,
      query:query,
    });
  }
  const handleShareDialogCancel = () => {
    storageUtil.removeLimitedItem('share=' + props.share);
    if (userSaveStore.url) {
      router.push(userSaveStore.url);
    }
    else {
      //販売実績一覧画面に遷移する
      router.push('/saleslist');
    }
  }

  const title = '-';
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <CheckAuth>
      </CheckAuth>

      {/* 検索結果共有ダイアログ */}
      {!shareID ? null :
      <SelectShareDialog
        share={shareID}
        open={openShareDialog}
        setOpen={setOpenShareDialog}
        callbackOK={handleShareDialogOK}
        callbackCancel={handleShareDialogCancel}
      ></SelectShareDialog>
      }

    </>
  );
};

//Export
export default Index;

